import { useContext } from 'react';

import { PermissionsContext } from './Permissions.context';
import type { IPermissionsProvider } from './Permissions.types';

const usePermissions = (): IPermissionsProvider => {
	const ctx = useContext(PermissionsContext);

	if (!ctx) throw new Error('usePermissions must be used inside <PermissionsProvider />');
	return ctx;
};

export default usePermissions;
